"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRefreshSessionMetadata = exports.REFRESH_MESSAGE = exports.METADATA_MESSAGE_TYPE = void 0;
var _reactSdk = require("@100mslive/react-sdk");
var _react = require("react");
var REFRESH_MESSAGE = "refresh";
exports.REFRESH_MESSAGE = REFRESH_MESSAGE;
var METADATA_MESSAGE_TYPE = "metadata";

/**
 * Refresh(re-populate) session metadata on receiving refresh broadcast message of type metadata
 */
exports.METADATA_MESSAGE_TYPE = METADATA_MESSAGE_TYPE;
var useRefreshSessionMetadata = function useRefreshSessionMetadata() {
  var hmsActions = (0, _reactSdk.useHMSActions)();
  var isConnected = (0, _reactSdk.useHMSStore)(_reactSdk.selectIsConnectedToRoom);
  (0, _react.useEffect)(function () {
    if (isConnected) {
      hmsActions.populateSessionMetadata();
    }
  }, [hmsActions, isConnected]);
  var onEvent = (0, _react.useCallback)(function (message) {
    if (message === REFRESH_MESSAGE) {
      hmsActions.populateSessionMetadata();
    }
  }, [hmsActions]);
  (0, _reactSdk.useCustomEvent)({
    type: METADATA_MESSAGE_TYPE,
    json: false,
    onEvent: onEvent
  });
};
exports.useRefreshSessionMetadata = useRefreshSessionMetadata;